/**
 * Parse confirm signup response
 * Transforms the confirmSignup API response to an app-friendly format
 * 
 * Example API response:
 * {
 *   "statusCode": 200,
 *   "message": "Signup confirmed successfully",
 *   "result": {
 *     "accessToken": "abcd1234",
 *     "refreshToken": "xyz5678",
 *     "expiresIn": 3600,
 *     "customer": {
 *       "id": 15,
 *       "name": "John Doe",
 *       "email": "john@example.com",
 *       "mobile": "9999999999",
 *       "customerRefId": "CUST-001",
 *       "isEmailVerified": true,
 *       "isMobileVerified": true,
 *       "isActive": true,
 *       "kycStatus": "PENDING",
 *       "raStatus": "PENDING"
 *     }
 *   }
 * }
 */

export const parseConfirmSignupResponse = (response) => {
  const isSuccess = response?.success === true || (response?.statusCode >= 200 && response?.statusCode < 300);

  if (!response || !response.result) {
    return {
      user: null,
      tokens: null,
      success: isSuccess,
      message: response?.message || "Invalid response format",
    };
  }

  const { result } = response;

  return {
    user: {
      id: result?.customer?.id || null,
      name: result?.customer?.name || "",
      email: result?.customer?.email || "",
      mobile: result?.customer?.mobile || "",
      customerRefId: result?.customer?.customerRefId || "",
      isEmailVerified: result?.customer?.isEmailVerified || false,
      isMobileVerified: result?.customer?.isMobileVerified || false,
      isActive: result?.customer?.isActive || false,
      kycStatus: result?.customer?.kycStatus || "PENDING",
      raStatus: result?.customer?.raStatus || "PENDING",
    },
    tokens: {
      accessToken: result?.accessToken || null,
      refreshToken: result?.refreshToken || null,
      expiresIn: result?.expiresIn || 3600,
    },
    success: isSuccess,
    message: response?.message || "Signup confirmed successfully",
  };
};
